import { useState } from 'react';
import { RefreshCw } from 'lucide-react';

// Confirmación del correo de Mercado Pago antes de domiciliar (17-oct-2026, Cenizas del Sol
// t1000025): MP amarra la suscripción a la cuenta MP con ESE correo; si el dueño entra a MP con
// otra, MP no lo deja autorizar («Tu e-mail no coincide con el de la suscripción»).
// Prellenado con el correo de la cuenta de Lealify; el backend lo valida otra vez.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface Props {
  defaultEmail: string;
  busy: boolean;
  onConfirm: (email: string) => void;
  onCancel: () => void;
}

export default function MpPayerEmailField({ defaultEmail, busy, onConfirm, onCancel }: Props) {
  const [email, setEmail] = useState(defaultEmail || '');
  const limpio = email.trim().toLowerCase();
  const valido = limpio.length > 0 && limpio.length <= 254 && EMAIL_RE.test(limpio);
  return (
    <form
      data-testid="mp-payer-email"
      className="mt-3 rounded-lg border border-line bg-surface-2 p-4"
      onSubmit={(e) => { e.preventDefault(); if (valido && !busy) onConfirm(limpio); }}
    >
      <label htmlFor="mp-payer-email" className="block text-sm font-medium text-content">
        Correo de tu cuenta de Mercado Pago
      </label>
      <input
        id="mp-payer-email"
        type="email"
        autoComplete="email"
        inputMode="email"
        maxLength={254}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="mt-1 w-full rounded-lg border border-line bg-surface px-3 py-2.5 text-sm text-content outline-none focus:border-accent/50"
        placeholder="tu@correo.com"
      />
      <p className="mt-1 text-xs text-content-3">
        Debe ser el correo con el que entras a Mercado Pago; si no coincide, MP no te deja autorizar.
      </p>
      {!valido && limpio.length > 0 && <p className="mt-1 text-xs text-red-600">Revisa el correo: no parece válido.</p>}
      <div className="mt-3 flex flex-wrap gap-2">
        <button
          type="submit"
          disabled={!valido || busy}
          className="inline-flex items-center gap-2 rounded-md bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          <RefreshCw className="h-4 w-4" /> {busy ? 'Abriendo Mercado Pago…' : 'Continuar a Mercado Pago'}
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={onCancel}
          className="rounded-md border border-line bg-surface px-4 py-2 text-sm font-medium text-content hover:bg-canvas disabled:opacity-60"
        >
          Cancelar
        </button>
      </div>
    </form>
  );
}
